export default __webpack_public_path__ + "static/media/Check_green.d8442966.svg";